<template>
  <f7-page name="default">
    <!--<a href="/customers/">customers</a>-->
  </f7-page>
</template>
<script>
  export default {
    name: 'default'
  };
</script>